export default [
    {
      path: '/dictionary',
      component: () => import('./views/Index'),
      name: 'dictionary',
      redirect: { name: 'dictionary-list' },
      children: [
        {
          path: '',
          name: 'dictionary-list',
          component: () => import('./views/List'),
          meta: {
            resource: 'auth',
          },
        },
        {
          path: ':id',
          name: 'dictionary-detail',
          component: () => import('./views/Detail'),
          meta: {
            resource: 'auth',
          },
        },
      ],
    },
  ]
  